module.exports = __webpack_public_path__ + "static/img/meiti2.034d22c6.png";